module.exports = __webpack_public_path__ + "img/convertShapeOutlineWhite.2236b76.svg";